module.exports = __webpack_public_path__ + "img/logo-arcavs.59f38d9b.jpg";